<template>
  <div class="DatePickerMonths">
    <div v-for="(month, index) in months" class="month" :class="{selected: index == selectedMonth}" @click="emit('monthSelected', index)">
      {{ month }}
    </div>
  </div>  
</template>

<script setup>
import { computed } from "vue";

const props = defineProps([ "date" ]);
const emit = defineEmits([ "monthSelected" ]);
const months = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
const selectedMonth = computed(() => {
  return props.date?.getUTCMonth();
});
</script>

<style scoped>
.DatePickerMonths {
  height: 440px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 1fr
}
.month {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
.month:hover {
  background: var(--gray-100);
}
.month.selected {
  background: var(--blue-50);
  border: 1px dotted var(--blue-100);
}
</style>